import axios from "axios";
import { getApiBaseUrl } from "./../config/Production";

const api = axios.create({
  baseURL: getApiBaseUrl(),
  withCredentials: true, // for sanctum cookies, if needed
});

// REQUEST INTERCEPTOR
api.interceptors.request.use((config) => {
  // Auto-attach token
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;
